enum SideSectionTab {
  Details = 'details',
  WorkUnits = 'work_units',
}

enum WorkUnitsSortOption {
  CreatedDate = 'created_date',
  Type = 'type',
  Points = 'points',
}

type MetricsResult = {
  averageValue: number | null;
  trendSlope: number | null;
  forecast: number | null;
};

type InfoItem = {
  color: string;
  icon: string;
  label: string;
  value: string;
};

export { SideSectionTab, WorkUnitsSortOption };
export type { InfoItem, MetricsResult };
